import { render, staticRenderFns } from "./PostalCodes.vue?vue&type=template&id=c3a8075e"
import script from "./PostalCodes.vue?vue&type=script&lang=js"
export * from "./PostalCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a8075e')) {
      api.createRecord('c3a8075e', component.options)
    } else {
      api.reload('c3a8075e', component.options)
    }
    module.hot.accept("./PostalCodes.vue?vue&type=template&id=c3a8075e", function () {
      api.rerender('c3a8075e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PostalCodes.vue"
export default component.exports